import { Routes } from '@angular/router';
// Archivo - Comercial
// Archivo - Productos
// Archivo - Inventario
// Archivo - Proveedores
// Archivo - Financiero
// Archivo - Bancos
// Archivo - Gastos
// Archivo - Configuración General
// Ventas - subopciones
// Stock - subopciones
// Bancos - subopciones
// Administración - subopciones
// import { BackupComponent } from './pages/employee/herramientas/backup/backup.component';  // desruteada: mostraba backups inventados
import { authGuard } from './core/guards/auth.guard';
import { adminGuard } from './core/guards/admin.guard';
import { guestGuard } from './core/guards/guest.guard';
import { tenantGuard } from './core/guards/tenant.guard';
import { employeeAuthGuard } from './core/guards/employee-auth.guard';
import { ownerGuard } from './core/guards/owner.guard';
import { ownerOnlyGuard } from './core/guards/owner-only.guard';
import { permissionGuard, permissionGuardAny, pantallaGuard } from './core/guards/permission.guard';
import { contextRedirectGuard } from './core/guards/context-redirect.guard';
import { POS_MODERNO_ACTIVO } from './core/config/pos';


export const routes: Routes = [
  // Redirect root based on context (tenant vs central domain)
  {
    path: '',
    canActivate: [contextRedirectGuard],
    children: []
  },

  // Página pública: qué hace el sistema y los precios (tareas 287–288)
  {
    path: 'planes',
    loadComponent: () => import('./pages/publico/planes/planes-publico.component').then(m => m.PlanesPublicoComponent),
    title: 'Planes y precios | CodeLand'
  },
  // Términos y privacidad, que el registro pide aceptar (tarea 270)
  {
    path: 'terminos',
    loadComponent: () => import('./pages/publico/legal/documento-legal.component').then(m => m.DocumentoLegalComponent),
    data: { documento: 'terminos' },
    title: 'Términos y condiciones | CodeLand'
  },
  {
    path: 'privacidad',
    loadComponent: () => import('./pages/publico/legal/documento-legal.component').then(m => m.DocumentoLegalComponent),
    data: { documento: 'privacidad' },
    title: 'Política de privacidad | CodeLand'
  },

  // Public routes - Login siempre accesible (maneja redirección internamente si está autenticado)
  {
    path: 'login',
    loadComponent: () => import('./pages/auth-pages/sign-in/sign-in.component').then(m => m.SignInComponent),
    canActivate: [guestGuard],
    title: 'Sign In | CodeLand SaaS'
  },
  {
    path: 'signup',
    loadComponent: () => import('./pages/auth-pages/sign-up/sign-up.component').then(m => m.SignUpComponent),
    canActivate: [guestGuard],
    title: 'Sign Up | CodeLand SaaS'
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./pages/auth-pages/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent),
    canActivate: [guestGuard],
    title: 'Forgot Password | CodeLand SaaS'
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./pages/auth-pages/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
    canActivate: [guestGuard],
    title: 'Reset Password | CodeLand SaaS'
  },
  {
    path: 'auth/google/callback',
    loadComponent: () => import('./pages/auth-pages/google-callback/google-callback.component').then(m => m.GoogleCallbackComponent),
    title: 'Autenticando con Google | CodeLand SaaS'
  },
  {
    path: 'onboarding',
    loadComponent: () => import('./pages/auth-pages/onboarding/onboarding.component').then(m => m.OnboardingComponent),
    canActivate: [authGuard],
    title: 'Configurá tu cuenta | CodeLand SaaS'
  },

  // Employee routes (tenant context)
  {
    path: 'employee/login',
    loadComponent: () => import('./pages/employee/employee-login/employee-login.component').then(m => m.EmployeeLoginComponent),
    title: 'Login de Empleados | CodeLand SaaS'
  },
  {
    path: 'employee/forgot-password',
    loadComponent: () => import('./pages/employee/employee-forgot-password/employee-forgot-password.component').then(m => m.EmployeeForgotPasswordComponent),
    title: 'Recuperar contraseña | CodeLand SaaS'
  },
  {
    path: 'employee/reset-password',
    loadComponent: () => import('./pages/employee/employee-reset-password/employee-reset-password.component').then(m => m.EmployeeResetPasswordComponent),
    title: 'Crear contraseña nueva | CodeLand SaaS'
  },
  
  // Payment result pages
  {
    path: 'payment/success',
    loadComponent: () => import('./pages/owner/payment-success/payment-success.component').then(m => m.PaymentSuccessComponent),
    title: 'Pago Exitoso | CodeLand SaaS'
  },
  {
    path: 'payment/failure',
    loadComponent: () => import('./pages/owner/payment-failure/payment-failure.component').then(m => m.PaymentFailureComponent),
    title: 'Pago Fallido | CodeLand SaaS'
  },
  {
    path: 'payment/pending',
    loadComponent: () => import('./pages/owner/payment-pending/payment-pending.component').then(m => m.PaymentPendingComponent),
    title: 'Pago Pendiente | CodeLand SaaS'
  },
  
  // Employee app routes (requires tenant + authentication)
  {
    path: 'app',
    loadComponent: () => import('./shared/layout/employee-layout/employee-layout.component').then(m => m.EmployeeLayoutComponent),
    canActivate: [tenantGuard, employeeAuthGuard],
    // Permiso por pantalla (core/config/permisos-pantallas.ts), el mismo que usa el menú.
    canActivateChild: [pantallaGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/employee/employee-dashboard/employee-dashboard.component').then(m => m.EmployeeDashboardComponent),
        title: 'Dashboard | Sistema'
      },
      {
        path: 'plan-no-incluye',
        loadComponent: () => import('./pages/employee/plan-no-incluye/plan-no-incluye.component').then(m => m.PlanNoIncluyeComponent),
        title: 'Tu plan no incluye esto | Sistema'
      },
      {
        path: 'notificaciones',
        loadComponent: () => import('./pages/notificaciones/notificaciones-page.component').then(m => m.NotificacionesPageComponent),
        title: 'Notificaciones | Sistema'
      },
      POS_MODERNO_ACTIVO
        ? {
            path: 'vender-pro',
            loadComponent: () => import('./pages/employee/vender-pro/vender-pro.component').then(m => m.VenderProComponent),
            title: 'Vender Pro | Sistema'
          }
        : { path: 'vender-pro', redirectTo: 'ventas/vender', pathMatch: 'full' },
      {
        path: 'archivo',
        canActivate: [permissionGuardAny(['articulos.ver', 'clientes.ver', 'proveedores.ver', 'vendedores.ver', 'geografia.ver'])],
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/employee/archivo/archivo.component').then(m => m.ArchivoComponent),
            title: 'Archivo | Sistema'
          },
          // Comercial
          {
            path: 'clientes',
            loadComponent: () => import('./pages/employee/archivo/comercial/clientes/clientes.component').then(m => m.ClientesComponent),
            title: 'Clientes | Sistema'
          },
          {
            path: 'vendedores',
            loadComponent: () => import('./pages/employee/archivo/comercial/vendedores/vendedores.component').then(m => m.VendedoresComponent),
            title: 'Vendedores | Sistema'
          },
          {
            path: 'listas-precios',
            loadComponent: () => import('./pages/employee/archivo/comercial/precios-archivo/precios-archivo.component').then(m => m.PreciosArchivoComponent),
            title: 'Listas de Precios | Sistema'
          },
          // Productos
          {
            path: 'productos',
            loadComponent: () => import('./pages/employee/archivo/productos/productos/productos.component').then(m => m.ProductosComponent),
            title: 'Productos | Sistema'
          },
          {
            path: 'familias',
            loadComponent: () => import('./pages/employee/archivo/productos/familias/familias.component').then(m => m.FamiliasComponent),
            title: 'Familias | Sistema'
          },
          {
            path: 'marcas',
            loadComponent: () => import('./pages/employee/archivo/productos/marcas/marcas.component').then(m => m.MarcasComponent),
            title: 'Marcas | Sistema'
          },
          {
            path: 'rubros',
            loadComponent: () => import('./pages/employee/archivo/productos/rubros/rubros.component').then(m => m.RubrosComponent),
            title: 'Rubros | Sistema'
          },
          {
            path: 'etiquetas',
            loadComponent: () => import('./pages/employee/archivo/productos/etiquetas/etiquetas.component').then(m => m.EtiquetasComponent),
            title: 'Etiquetas | Sistema'
          },
          {
            path: 'unidades-negocio',
            loadComponent: () => import('./pages/employee/archivo/productos/unidades-negocio/unidades-negocio.component').then(m => m.UnidadesNegocioComponent),
            title: 'Unidades de Negocio | Sistema'
          },
          {
            path: 'unidades-medida',
            loadComponent: () => import('./pages/employee/archivo/productos/unidades-medida/unidades-medida.component').then(m => m.UnidadesMedidaComponent),
            title: 'Unidades de Medida | Sistema'
          },
          // Inventario
          {
            path: 'depositos',
            loadComponent: () => import('./pages/employee/archivo/inventario/depositos/depositos.component').then(m => m.DepositosComponent),
            title: 'Depósitos | Sistema'
          },
          // Proveedores
          {
            path: 'proveedores',
            loadComponent: () => import('./pages/employee/archivo/proveedores/proveedores/proveedores.component').then(m => m.ProveedoresComponent),
            title: 'Proveedores | Sistema'
          },
          {
            path: 'rubros-iva-compras',
            loadComponent: () => import('./pages/employee/archivo/proveedores/rubros-iva-compras/rubros-iva-compras.component').then(m => m.RubrosIvaComprasComponent),
            title: 'Rubros IVA Compras | Sistema'
          },
          // Financiero
          {
            path: 'tarjetas',
            loadComponent: () => import('./pages/employee/archivo/financiero/tarjetas/tarjetas.component').then(m => m.TarjetasComponent),
            title: 'Tarjetas | Sistema'
          },
          {
            path: 'transportes',
            loadComponent: () => import('./pages/employee/archivo/financiero/transportes/transportes.component').then(m => m.TransportesComponent),
            title: 'Transportes | Sistema'
          },
          {
            path: 'recargos-financiacion',
            loadComponent: () => import('./pages/employee/archivo/financiero/recargos-financiacion/recargos-financiacion.component').then(m => m.RecargosFinanciacionComponent),
            title: 'Recargos Financiación | Sistema'
          },
          {
            path: 'recargos-mora',
            loadComponent: () => import('./pages/employee/archivo/financiero/recargos-mora/recargos-mora.component').then(m => m.RecargosMoraComponent),
            title: 'Recargos Mora | Sistema'
          },
          // Bancos
          {
            path: 'bancos-entidades',
            loadComponent: () => import('./pages/employee/archivo/bancos/bancos-archivo/bancos-archivo.component').then(m => m.BancosArchivoComponent),
            title: 'Bancos | Sistema'
          },
          {
            path: 'cuentas-bancarias',
            loadComponent: () => import('./pages/employee/archivo/bancos/cuentas-bancarias/cuentas-bancarias.component').then(m => m.CuentasBancariasComponent),
            title: 'Cuentas Bancarias | Sistema'
          },
          {
            path: 'estados-cheques',
            loadComponent: () => import('./pages/employee/archivo/bancos/estados-cheques/estados-cheques.component').then(m => m.EstadosChequesComponent),
            title: 'Estados Cheques | Sistema'
          },
          // Gastos
          {
            path: 'rubros-gastos',
            loadComponent: () => import('./pages/employee/archivo/gastos/rubros-gastos/rubros-gastos.component').then(m => m.RubrosGastosComponent),
            title: 'Rubros de Gastos | Sistema'
          },
          {
            path: 'grupos-costos',
            loadComponent: () => import('./pages/employee/archivo/gastos/grupos-costos/grupos-costos.component').then(m => m.GruposCostosComponent),
            title: 'Grupos de Costos | Sistema'
          },
          // Configuración General
          {
            path: 'paises',
            loadComponent: () => import('./pages/employee/archivo/config-general/paises/paises.component').then(m => m.PaisesComponent),
            title: 'Países | Sistema'
          },
          {
            path: 'provincias',
            loadComponent: () => import('./pages/employee/archivo/config-general/provincias/provincias.component').then(m => m.ProvinciasComponent),
            title: 'Provincias | Sistema'
          },
          {
            path: 'ciudades',
            loadComponent: () => import('./pages/employee/archivo/config-general/ciudades/ciudades.component').then(m => m.CiudadesComponent),
            title: 'Ciudades | Sistema'
          },
          {
            path: 'tipos-turnos',
            loadComponent: () => import('./pages/employee/archivo/config-general/tipos-turnos/tipos-turnos.component').then(m => m.TiposTurnosComponent),
            title: 'Tipos de Turnos | Sistema'
          },
          {
            path: 'socios',
            loadComponent: () => import('./pages/employee/archivo/config-general/socios/socios.component').then(m => m.SociosComponent),
            title: 'Socios | Sistema'
          }
        ]
      },
      {
        path: 'ventas',
        canActivate: [permissionGuardAny(['ventas.ver', 'cobranzas.ver', 'caja.ver'])],
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/employee/ventas/ventas.component').then(m => m.VentasComponent),
            title: 'Ventas | Sistema'
          },
          // Operaciones
          { path: 'vender', loadComponent: () => import('./pages/employee/ventas/vender/vender.component').then(m => m.VenderComponent), title: 'Vender | Sistema' },
          // 'cobrar-cuenta' se unificó en punto-cobranzas (tarea 129): era la versión
          // simple, sin imputación a cuotas ni vendedor. Se redirige por los links guardados.
          { path: 'cobrar-cuenta', redirectTo: 'punto-cobranzas', pathMatch: 'full' },
          { path: 'punto-cobranzas', loadComponent: () => import('./pages/employee/ventas/punto-cobranzas/punto-cobranzas.component').then(m => m.PuntoCobranzasComponent), title: 'Punto de Cobranzas | Sistema' },
          { path: 'gastos', loadComponent: () => import('./pages/employee/ventas/gastos/gastos-ventas.component').then(m => m.GastosVentasComponent), title: 'Gastos | Sistema' },
          { path: 'ficha-cliente', loadComponent: () => import('./pages/employee/ventas/ficha-cliente/ficha-cliente.component').then(m => m.FichaClienteComponent), title: 'Ficha Cliente | Sistema' },
          {
            path: 'comprobantes-fiscales',
            loadComponent: () => import('./pages/employee/ventas/comprobantes-fiscales/comprobantes-fiscales.component').then(m => m.ComprobantesFiscalesComponent),
            title: 'Comprobantes Fiscales | Sistema'
          },
          // Caja e Impresor Fiscal
          {
            path: 'cajas',
            children: [
              { path: '', loadComponent: () => import('./pages/employee/ventas/cajas/cajas.component').then(m => m.CajasComponent), title: 'Cajas | Sistema' },
              { path: 'abrir-turno', loadComponent: () => import('./pages/employee/ventas/cajas/abrir-turno/abrir-turno.component').then(m => m.AbrirTurnoComponent), title: 'Abrir Turno | Sistema' },
              { path: 'cerrar-turno/:id', loadComponent: () => import('./pages/employee/ventas/cajas/cerrar-turno/cerrar-turno.component').then(m => m.CerrarTurnoComponent), title: 'Cerrar Turno | Sistema' },
            ]
          },
          { path: 'impresor-fiscal/cierre-z', loadComponent: () => import('./pages/employee/ventas/cierre-z/cierre-z.component').then(m => m.CierreZComponent), title: 'Cierre Z | Sistema' },
          { path: 'impresor-fiscal/cancelar-documento', loadComponent: () => import('./pages/employee/ventas/cancelar-documento/cancelar-documento.component').then(m => m.CancelarDocumentoComponent), title: 'Cancelar Documento | Sistema' },
          { path: 'impresor-fiscal/reimprimir-zeta', loadComponent: () => import('./pages/employee/ventas/reimprimir-zeta/reimprimir-zeta.component').then(m => m.ReimprimirZetaComponent), title: 'Reimprimir Zeta | Sistema' },
          // Historial y Cobros
          { path: 'historial', loadComponent: () => import('./pages/employee/ventas/historial/historial-ventas.component').then(m => m.HistorialVentasComponent), title: 'Historial de Ventas | Sistema' },
          { path: 'cobros-ctacte', loadComponent: () => import('./pages/employee/ventas/cobros-ctacte/cobros-ctacte.component').then(m => m.CobrosCtacteComponent), title: 'Cobros Cta. Cte. | Sistema' },
          { path: 'presupuestos', loadComponent: () => import('./pages/employee/ventas/presupuestos/presupuestos.component').then(m => m.PresupuestosComponent), title: 'Presupuestos | Sistema' },
          // Facturación electrónica: la pantalla real es 'comprobantes-fiscales', más
          // abajo. Las tres maquetas que vivían acá (CAE y números inventados, copiados
          // del FoxPro) se borraron el 2026-09-09: estaban desruteadas desde Fase 0 pero
          // seguían en el repo, y ya no son referencia de diseño de nada.

          // Comprobantes Manuales
          { path: 'remitos', loadComponent: () => import('./pages/employee/ventas/remitos/remitos-ventas.component').then(m => m.RemitosVentasComponent), title: 'Remitos | Sistema' },
          { path: 'notas-debito', loadComponent: () => import('./pages/employee/ventas/notas-debito/notas-debito-ventas.component').then(m => m.NotasDebitoVentasComponent), title: 'Notas de Débito | Sistema' },
          { path: 'notas-credito', loadComponent: () => import('./pages/employee/ventas/notas-credito/notas-credito-ventas.component').then(m => m.NotasCreditoVentasComponent), title: 'Notas de Crédito | Sistema' },
          // Preventas
          { path: 'preventas-pendientes', loadComponent: () => import('./pages/employee/ventas/preventas-pendientes/preventas-pendientes.component').then(m => m.PreventasPendientesComponent), title: 'Gestor de Preventas | Sistema' },
          // 'historial-preventas' BORRADA (tarea 143): eran 645 líneas de datos
          // inventados sin servicio detrás. La preventa real vive en ventas/preventas-pendientes.
        ]
      },
      {
        path: 'stock',
        canActivate: [permissionGuardAny(['stock.ver'])],
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/employee/stock/stock.component').then(m => m.StockComponent),
            title: 'Stock | Sistema'
          },
          {
            path: 'consulta',
            loadComponent: () => import('./pages/employee/stock/consulta-stock/consulta-stock.component').then(m => m.ConsultaStockComponent),
            title: 'Consulta de Stock | Sistema'
          },
          {
            path: 'ficha-producto',
            loadComponent: () => import('./pages/employee/stock/ficha-producto/ficha-producto.component').then(m => m.FichaProductoComponent),
            title: 'Ficha de Producto | Sistema'
          },
          {
            path: 'arqueos',
            loadComponent: () => import('./pages/employee/stock/arqueos/arqueos.component').then(m => m.ArqueosComponent),
            title: 'Arqueos de Stock | Sistema'
          },
          { path: 'entradas', loadComponent: () => import('./pages/employee/stock/entradas/entradas.component').then(m => m.EntradasComponent), title: 'Entradas de Stock | Sistema' },
          { path: 'salidas', loadComponent: () => import('./pages/employee/stock/salidas/salidas.component').then(m => m.SalidasComponent), title: 'Salidas de Stock | Sistema' },
          { path: 'transferencias-depositos', loadComponent: () => import('./pages/employee/stock/transferencias-depositos/transferencias-depositos.component').then(m => m.TransferenciasDepositosComponent), title: 'Transferencias entre Depósitos | Sistema' },
        ]
      },
      {
        path: 'bancos',
        canActivate: [permissionGuardAny(['bancos.ver', 'cheques.ver'])],
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/employee/bancos/bancos.component').then(m => m.BancosComponent),
            title: 'Bancos | Sistema'
          },
          { path: 'cheques-tercero', loadComponent: () => import('./pages/employee/bancos/cheques-tercero/cheques-tercero.component').then(m => m.ChequesTerceroComponent), title: 'Cheques de Tercero | Sistema' },
          { path: 'movimientos', loadComponent: () => import('./pages/employee/bancos/movimientos/movimientos-bancarios.component').then(m => m.MovimientosBancariosComponent), title: 'Movimientos Bancarios | Sistema' },
        ]
      },
      {
        path: 'informes',
        canActivate: [permissionGuardAny(['informes.ver'])],
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/employee/informes/informes.component').then(m => m.InformesComponent),
            title: 'Informes | Sistema'
          },
          {
            path: 'ventas/del-dia',
            loadComponent: () => import('./pages/employee/informes/ventas/del-dia/informe-ventas-dia.component').then(m => m.InformeVentasDiaComponent),
            title: 'Ventas del Día | Sistema'
          },
          {
            path: 'ventas/por-periodo',
            loadComponent: () => import('./pages/employee/informes/ventas/por-periodo/informe-ventas-periodo.component').then(m => m.InformeVentasPeriodoComponent),
            title: 'Ventas por Período | Sistema'
          },
          {
            path: 'ventas/por-cliente',
            loadComponent: () => import('./pages/employee/informes/ventas/por-cliente/informe-ventas-cliente.component').then(m => m.InformeVentasClienteComponent),
            title: 'Ventas por Cliente | Sistema'
          },
          {
            path: 'ventas/por-articulo',
            loadComponent: () => import('./pages/employee/informes/ventas/por-articulo/informe-ventas-articulo.component').then(m => m.InformeVentasArticuloComponent),
            title: 'Ventas por Artículo | Sistema'
          },
          {
            path: 'ventas/ranking',
            loadComponent: () => import('./pages/employee/informes/ventas/ranking/informe-ranking-productos.component').then(m => m.InformeRankingProductosComponent),
            title: 'Ranking de Productos | Sistema'
          },
          {
            path: 'ventas/rentabilidad',
            loadComponent: () => import('./pages/employee/informes/ventas/rentabilidad/informe-rentabilidad.component').then(m => m.InformeRentabilidadComponent),
            title: 'Rentabilidad | Sistema'
          },
          { path: 'stock/actual', loadComponent: () => import('./pages/employee/informes/stock/actual/informe-stock-actual.component').then(m => m.InformeStockActualComponent), title: 'Stock Actual | Sistema' },
          { path: 'stock/critico', loadComponent: () => import('./pages/employee/informes/stock/stock-critico/stock-critico.component').then(m => m.StockCriticoComponent), title: 'Stock Crítico | Sistema' },
          { path: 'stock/valorizacion', loadComponent: () => import('./pages/employee/informes/stock/valorizacion/informe-stock-valorizacion.component').then(m => m.InformeStockValorizacionComponent), title: 'Valorización de Stock | Sistema' },
          { path: 'stock/movimientos', loadComponent: () => import('./pages/employee/informes/stock/movimientos/informe-stock-movimientos.component').then(m => m.InformeStockMovimientosComponent), title: 'Movimientos de Stock | Sistema' },
          { path: 'stock/por-vencer', loadComponent: () => import('./pages/employee/informes/stock/por-vencer/informe-por-vencer.component').then(m => m.InformePorVencerComponent), title: 'Artículos por Vencer | Sistema' },
          { path: 'ventas/clientes-inactivos', loadComponent: () => import('./pages/employee/informes/ventas/clientes-inactivos/informe-clientes-inactivos.component').then(m => m.InformeClientesInactivosComponent), title: 'Clientes Inactivos | Sistema' },
          { path: 'pagos/por-pagar', loadComponent: () => import('./pages/employee/informes/pagos/por-pagar/informe-cuentas-pagar.component').then(m => m.InformeCuentasPagarComponent), title: 'Cuentas por Pagar | Sistema' },
          { path: 'pagos/del-dia', loadComponent: () => import('./pages/employee/informes/pagos/pagos/informe-pagos.component').then(m => m.InformePagosComponent), data: { modo: 'dia' }, title: 'Pagos del Día | Sistema' },
          { path: 'pagos/por-periodo', loadComponent: () => import('./pages/employee/informes/pagos/pagos/informe-pagos.component').then(m => m.InformePagosComponent), data: { modo: 'periodo' }, title: 'Pagos por Período | Sistema' },
          { path: 'pagos/cheques', loadComponent: () => import('./pages/employee/informes/pagos/cheques/informe-cheques.component').then(m => m.InformeChequesComponent), title: 'Cheques | Sistema' },
          { path: 'tesoreria/resumen-caja', loadComponent: () => import('./pages/employee/informes/tesoreria/resumen-caja/informe-resumen-caja.component').then(m => m.InformeResumenCajaComponent), title: 'Resumen de Caja | Sistema' },
          { path: 'tesoreria/turnos', loadComponent: () => import('./pages/employee/informes/tesoreria/turnos/informe-turnos.component').then(m => m.InformeTurnosComponent), title: 'Turnos / Arqueos | Sistema' },
          { path: 'gastos/del-dia', loadComponent: () => import('./pages/employee/informes/gastos/gastos/informe-gastos.component').then(m => m.InformeGastosComponent), data: { modo: 'dia' }, title: 'Gastos del Día | Sistema' },
          { path: 'gastos/por-periodo', loadComponent: () => import('./pages/employee/informes/gastos/gastos/informe-gastos.component').then(m => m.InformeGastosComponent), data: { modo: 'periodo' }, title: 'Gastos por Período | Sistema' },
          { path: 'gastos/por-rubro', loadComponent: () => import('./pages/employee/informes/gastos/por-rubro/informe-gastos-rubro.component').then(m => m.InformeGastosRubroComponent), title: 'Gastos por Rubro | Sistema' },
          { path: 'gastos/por-proveedor', loadComponent: () => import('./pages/employee/informes/gastos/por-proveedor/informe-gastos-proveedor.component').then(m => m.InformeGastosProveedorComponent), title: 'Gastos por Proveedor | Sistema' },
          // Los tres exponen plata del negocio y el backend los pide con
          // 'informes.financieros'. Sin el guard fino acá, un usuario con sólo
          // 'informes.ver' entraba a la pantalla y comía un 403 al cargar.
          {
            path: 'gerenciales/resultado',
            loadComponent: () => import('./pages/employee/informes/gerenciales/resultado/informe-resultado.component').then(m => m.InformeResultadoComponent),
            canActivate: [permissionGuardAny(['informes.financieros'])],
            title: 'Resultado del Período | Sistema'
          },
          {
            path: 'gerenciales/evolucion',
            loadComponent: () => import('./pages/employee/informes/gerenciales/evolucion/informe-evolucion.component').then(m => m.InformeEvolucionComponent),
            canActivate: [permissionGuardAny(['informes.financieros'])],
            title: 'Evolución Mensual | Sistema'
          },
          {
            path: 'iva/ventas',
            loadComponent: () => import('./pages/employee/informes/iva/ventas/iva-ventas.component').then(m => m.IvaVentasComponent),
            canActivate: [permissionGuardAny(['informes.financieros'])],
            title: 'Libro de IVA Ventas | Sistema'
          },
          {
            // Une facturas de proveedor con gastos de caja: el credito fiscal del
            // comercio esta en las dos fuentes.
            path: 'iva/compras',
            loadComponent: () => import('./pages/employee/informes/iva/compras/iva-compras.component').then(m => m.IvaComprasComponent),
            canActivate: [permissionGuardAny(['informes.financieros'])],
            title: 'Libro de IVA Compras | Sistema'
          },
          {
            path: 'cobranzas/por-cobrar',
            loadComponent: () => import('./pages/employee/informes/cobranzas/por-cobrar/informe-cuentas-cobrar.component').then(m => m.InformeCuentasCobrarComponent),
            title: 'Cuentas por Cobrar | Sistema'
          },
          {
            path: 'cobranzas/del-dia',
            loadComponent: () => import('./pages/employee/informes/cobranzas/cobros/informe-cobros.component').then(m => m.InformeCobrosComponent),
            data: { modo: 'dia' },
            title: 'Cobros del Día | Sistema'
          },
          {
            path: 'cobranzas/por-periodo',
            loadComponent: () => import('./pages/employee/informes/cobranzas/cobros/informe-cobros.component').then(m => m.InformeCobrosComponent),
            data: { modo: 'periodo' },
            title: 'Cobros por Período | Sistema'
          },
          {
            path: 'cobranzas/antiguacion',
            loadComponent: () => import('./pages/employee/informes/cobranzas/antiguacion/informe-antiguacion.component').then(m => m.InformeAntiguacionComponent),
            title: 'Antigüedad de Saldos | Sistema'
          },
          {
            path: 'listados/articulos',
            loadComponent: () => import('./pages/employee/informes/listados/articulos/informe-articulos.component').then(m => m.InformeArticulosComponent),
            title: 'Artículos | Sistema'
          },
          {
            path: 'listados/precios',
            loadComponent: () => import('./pages/employee/informes/listados/precios/informe-lista-precios.component').then(m => m.InformeListaPreciosComponent),
            title: 'Lista de Precios | Sistema'
          },
          {
            path: 'listados/clientes',
            loadComponent: () => import('./pages/employee/informes/listados/clientes/informe-clientes.component').then(m => m.InformeClientesComponent),
            title: 'Clientes | Sistema'
          },
          {
            path: 'listados/proveedores',
            loadComponent: () => import('./pages/employee/informes/listados/proveedores/informe-proveedores.component').then(m => m.InformeProveedoresComponent),
            title: 'Proveedores | Sistema'
          },
          {
            path: 'listados/etiquetas',
            loadComponent: () => import('./pages/employee/informes/listados/etiquetas/informe-etiquetas.component').then(m => m.InformeEtiquetasComponent),
            title: 'Etiquetas de Precios | Sistema'
          },

        ]
      },
      {
        path: 'administracion',
        canActivate: [permissionGuardAny(['compras.ver', 'pagos.ver', 'proveedores.ver', 'gastos.ver', 'precios.ajuste_masivo'])],
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/employee/administracion/administracion.component').then(m => m.AdministracionComponent),
            title: 'Administración | Sistema'
          },
          // Precios y Facturación
          { path: 'ajustes-precios', loadComponent: () => import('./pages/employee/administracion/ajustes-precios/ajustes-precios.component').then(m => m.AjustesPreciosComponent), title: 'Ajustes de Precios | Sistema' },
          { path: 'facturas', loadComponent: () => import('./pages/employee/administracion/facturas/facturas-admin.component').then(m => m.FacturasAdminComponent), title: 'Facturas | Sistema' },
          // Proveedores
          // La pantalla de Compras se consolidó en la de Facturas, que carga el
          // mismo comprobante con desglose fiscal. Se redirige para no romper
          // los links guardados.
          { path: 'compras', redirectTo: 'facturas', pathMatch: 'full' },
          { path: 'pagos-proveedores', loadComponent: () => import('./pages/employee/administracion/pagos-proveedores/pagos-proveedores.component').then(m => m.PagosProveedoresComponent), title: 'Pagos a Proveedores | Sistema' },
          { path: 'cuenta-proveedores', loadComponent: () => import('./pages/employee/administracion/cuenta-proveedores/cuenta-proveedores.component').then(m => m.CuentaProveedoresComponent), title: 'Cuenta Proveedores | Sistema' },
          // Gastos
          { path: 'gastos', loadComponent: () => import('./pages/employee/administracion/gastos/gastos-admin.component').then(m => m.GastosAdminComponent), title: 'Gastos | Sistema' },
          // Comprobantes
          { path: 'notas-credito', loadComponent: () => import('./pages/employee/administracion/notas-credito/notas-credito-admin.component').then(m => m.NotasCreditoAdminComponent), title: 'Notas de Crédito | Sistema' },
          { path: 'notas-debito', loadComponent: () => import('./pages/employee/administracion/notas-debito/notas-debito-admin.component').then(m => m.NotasDebitoAdminComponent), title: 'Notas de Débito | Sistema' },
          // Sueldos
          { path: 'sueldos', loadComponent: () => import('./pages/employee/administracion/sueldos/sueldos-admin.component').then(m => m.SueldosAdminComponent), title: 'Sueldos | Sistema' },
          { path: 'personal', loadComponent: () => import('./pages/employee/administracion/personal/personal-admin.component').then(m => m.PersonalAdminComponent), title: 'Personal | Sistema' },
        ]
      },
      {
        path: 'herramientas',
        canActivate: [permissionGuardAny(['articulos.ver', 'precios.ver', 'clientes.ver', 'proveedores.ver', 'stock.ajustar'])],
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/employee/herramientas/herramientas.component').then(m => m.HerramientasComponent),
            title: 'Herramientas | Sistema'
          },
          {
            path: 'importar-precios',
            loadComponent: () => import('./pages/employee/herramientas/importar-precios/importar-precios.component').then(m => m.ImportarPreciosComponent),
            title: 'Importar Precios | Sistema'
          },
          {
            path: 'importar-datos',
            loadComponent: () => import('./pages/employee/herramientas/importar-datos/importar-datos.component').then(m => m.ImportarDatosComponent),
            title: 'Importar Datos | Sistema'
          },
          {
            path: 'exportar-datos',
            loadComponent: () => import('./pages/employee/herramientas/exportar-datos/exportar-datos.component').then(m => m.ExportarDatosComponent),
            title: 'Exportar Datos | Sistema'
          },
          {
            path: 'calculadora',
            loadComponent: () => import('./pages/employee/herramientas/calculadora/calculadora.component').then(m => m.CalculadoraComponent),
            title: 'Calculadora | Sistema'
          },
          {
            path: 'conversor',
            loadComponent: () => import('./pages/employee/herramientas/conversor/conversor.component').then(m => m.ConversorComponent),
            title: 'Conversión de Monedas | Sistema'
          },
          // 'backup' DESRUTEADA. La pantalla listaba backups inventados
          // (MOCK_BACKUPS en backup.service.ts) y le daba al comerciante la falsa
          // seguridad de que sus datos estaban resguardados, cuando no existía
          // ningún backup. El backup real ahora corre en el servidor
          // (php artisan backup:tenants, ver api/RESTORE.md). Esta pantalla vuelve
          // cuando haya un endpoint que liste los backups de verdad.
          //
          // { path: 'backup', component: BackupComponent, title: 'Backup | Sistema' }
        ]
      },
      {
        path: 'ayuda',
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/employee/ayuda/ayuda.component').then(m => m.AyudaComponent),
            title: 'Ayuda | Sistema'
          },
          {
            path: '**',
            redirectTo: ''
          }
        ]
      },
      {
        path: 'perfil',
        loadComponent: () => import('./pages/owner/profile/profile.component').then(m => m.ProfileComponent),
        title: 'Mi Perfil | Sistema'
      },
      // Configuración routes (protegidas por permisos)
      {
        path: 'configuracion',
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/employee/configuracion/configuracion.component').then(m => m.ConfiguracionComponent),
            title: 'Configuración | Sistema'
          },
          {
            path: 'usuarios',
            canActivate: [permissionGuard('usuarios.ver')],
            loadComponent: () => import('./pages/employee/configuracion/usuarios/usuarios-list.component').then(m => m.UsuariosListComponent),
            title: 'Gestión de Usuarios | Sistema'
          },
          {
            path: 'usuarios/nuevo',
            canActivate: [permissionGuard('usuarios.crear')],
            loadComponent: () => import('./pages/employee/configuracion/usuarios/usuario-form.component').then(m => m.UsuarioFormComponent),
            title: 'Nuevo Usuario | Sistema'
          },
          {
            path: 'usuarios/:id',
            canActivate: [permissionGuard('usuarios.editar')],
            loadComponent: () => import('./pages/employee/configuracion/usuarios/usuario-form.component').then(m => m.UsuarioFormComponent),
            title: 'Editar Usuario | Sistema'
          },
          {
            path: 'sucursales',
            canActivate: [permissionGuard('sucursales.ver')],
            loadComponent: () => import('./pages/employee/configuracion/sucursales/sucursales-list.component').then(m => m.SucursalesListComponent),
            title: 'Gestión de Sucursales | Sistema'
          },
          {
            path: 'sucursales/nuevo',
            canActivate: [permissionGuard('sucursales.crear')],
            loadComponent: () => import('./pages/employee/configuracion/sucursales/sucursal-form.component').then(m => m.SucursalFormComponent),
            title: 'Nueva Sucursal | Sistema'
          },
          {
            path: 'sucursales/:id',
            canActivate: [permissionGuard('sucursales.editar')],
            loadComponent: () => import('./pages/employee/configuracion/sucursales/sucursal-form.component').then(m => m.SucursalFormComponent),
            title: 'Editar Sucursal | Sistema'
          },
          {
            path: 'roles',
            canActivate: [permissionGuard('roles.ver')],
            loadComponent: () => import('./pages/employee/configuracion/roles/roles-list.component').then(m => m.RolesListComponent),
            title: 'Gestión de Roles y Permisos | Sistema'
          },
          {
            path: 'roles/nuevo',
            canActivate: [permissionGuard('roles.crear')],
            loadComponent: () => import('./pages/employee/configuracion/roles/rol-form.component').then(m => m.RolFormComponent),
            title: 'Nuevo Rol | Sistema'
          },
          {
            path: 'roles/:id',
            canActivate: [permissionGuard('roles.editar')],
            loadComponent: () => import('./pages/employee/configuracion/roles/rol-form.component').then(m => m.RolFormComponent),
            title: 'Editar Rol | Sistema'
          },
          {
            path: 'puntos-venta',
            canActivate: [permissionGuard('puntos_venta.ver')],
            loadComponent: () => import('./pages/employee/configuracion/puntos-venta/puntos-venta-list.component').then(m => m.PuntosVentaListComponent),
            title: 'Puntos de Venta | Sistema'
          },
          {
            path: 'puntos-venta/nuevo',
            canActivate: [permissionGuard('puntos_venta.crear')],
            loadComponent: () => import('./pages/employee/configuracion/puntos-venta/punto-venta-form.component').then(m => m.PuntoVentaFormComponent),
            title: 'Nuevo Punto de Venta | Sistema'
          },
          {
            path: 'puntos-venta/:id',
            canActivate: [permissionGuard('puntos_venta.editar')],
            loadComponent: () => import('./pages/employee/configuracion/puntos-venta/punto-venta-form.component').then(m => m.PuntoVentaFormComponent),
            title: 'Editar Punto de Venta | Sistema'
          },
          {
            path: 'preferencias',
            canActivate: [permissionGuard('configuracion.ver')],
            loadComponent: () => import('./pages/employee/configuracion/preferencias/preferencias.component').then(m => m.PreferenciasComponent),
            title: 'Preferencias del Negocio | Sistema'
          },
          {
            path: 'auditoria',
            canActivate: [permissionGuard('auditoria.ver')],
            loadComponent: () => import('./pages/employee/configuracion/auditoria/auditoria.component').then(m => m.AuditoriaComponent),
            title: 'Registro de acciones | Sistema'
          },
          {
            path: 'datos-fiscales',
            canActivate: [permissionGuard('configuracion.ver')],
            loadComponent: () => import('./pages/employee/configuracion/datos-fiscales/datos-fiscales.component').then(m => m.DatosFiscalesComponent),
            title: 'Datos Fiscales | Sistema'
          },
          {
            // Puntos de venta FISCALES de ARCA. Distinto de 'puntos-venta', que son las cajas.
            path: 'puntos-venta-afip',
            canActivate: [permissionGuard('puntos_venta.ver')],
            loadComponent: () => import('./pages/employee/configuracion/puntos-venta-afip/puntos-venta-afip.component').then(m => m.PuntosVentaAfipComponent),
            title: 'Puntos de Venta de ARCA | Sistema'
          }
        ]
      },
      // Owner-only routes (require is_owner = true)
      {
        path: 'mis-negocios',
        canActivate: [ownerOnlyGuard],
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/owner/businesses/businesses.component').then(m => m.BusinessesComponent),
            title: 'Mis Negocios | Sistema'
          },
          {
            path: 'nuevo',
            loadComponent: () => import('./pages/owner/business-form/business-form.component').then(m => m.BusinessFormComponent),
            title: 'Nuevo Negocio | Sistema'
          },
          {
            path: ':id',
            loadComponent: () => import('./pages/owner/business-form/business-form.component').then(m => m.BusinessFormComponent),
            title: 'Editar Negocio | Sistema'
          }
        ]
      },
      {
        path: 'mi-suscripcion',
        loadComponent: () => import('./pages/owner/subscription/subscription.component').then(m => m.SubscriptionComponent),
        canActivate: [ownerOnlyGuard],
        title: 'Mi Suscripción | Sistema'
      },
      {
        path: 'facturas-saas',
        loadComponent: () => import('./pages/owner/invoices/invoices.component').then(m => m.InvoicesComponent),
        canActivate: [ownerOnlyGuard],
        title: 'Mis Facturas SaaS | Sistema'
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      }
    ]
  },

  // Owner routes in central domain (for business selection)
  {
    path: 'owner',
    loadComponent: () => import('./shared/layout/app-layout/app-layout.component').then(m => m.AppLayoutComponent),
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        redirectTo: '/owner/profile',
        pathMatch: 'full'
      },
      {
        path: 'notificaciones',
        loadComponent: () => import('./pages/notificaciones/notificaciones-page.component').then(m => m.NotificacionesPageComponent),
        title: 'Notificaciones | CodeLand SaaS'
      },
      {
        path: 'businesses',
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/owner/businesses/businesses.component').then(m => m.BusinessesComponent),
            title: 'Mis Negocios | CodeLand SaaS'
          },
          {
            path: 'new',
            loadComponent: () => import('./pages/owner/business-form/business-form.component').then(m => m.BusinessFormComponent),
            title: 'Nuevo Negocio | CodeLand SaaS'
          },
          {
            path: ':id',
            loadComponent: () => import('./pages/owner/business-form/business-form.component').then(m => m.BusinessFormComponent),
            title: 'Editar Negocio | CodeLand SaaS'
          }
        ]
      },
      {
        path: 'perfil',
        loadComponent: () => import('./pages/owner/profile/profile.component').then(m => m.ProfileComponent),
        title: 'Mi Perfil | CodeLand SaaS'
      },
      {
        path: 'profile',
        loadComponent: () => import('./pages/owner/profile/profile.component').then(m => m.ProfileComponent),
        title: 'Mi Perfil | CodeLand SaaS'
      },
      {
        path: 'subscription',
        loadComponent: () => import('./pages/owner/subscription/subscription.component').then(m => m.SubscriptionComponent),
        title: 'Suscripción | CodeLand SaaS'
      },
      {
        path: 'invoices',
        loadComponent: () => import('./pages/owner/invoices/invoices.component').then(m => m.InvoicesComponent),
        title: 'Facturación | CodeLand SaaS'
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      }
    ]
  },

  // Admin routes (requires authentication + admin role)
  {
    path: 'admin',
    loadComponent: () => import('./shared/layout/app-layout/app-layout.component').then(m => m.AppLayoutComponent),
    canActivate: [authGuard, adminGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/admin/dashboard/dashboard.component').then(m => m.AdminDashboardComponent),
        title: 'Admin Dashboard | CodeLand SaaS'
      },
      {
        path: 'owners',
        loadComponent: () => import('./pages/admin/owners/owners.component').then(m => m.AdminOwnersComponent),
        title: 'Clientes | Admin | CodeLand SaaS'
      },
      {
        path: 'owners/:id',
        loadComponent: () => import('./pages/admin/owner-detail/owner-detail.component').then(m => m.AdminOwnerDetailComponent),
        title: 'Detalle de Cliente | Admin | CodeLand SaaS'
      },
      {
        path: 'invoices',
        loadComponent: () => import('./pages/admin/invoices/invoices.component').then(m => m.AdminInvoicesComponent),
        title: 'Facturas | Admin | CodeLand SaaS'
      },
      {
        path: 'payment-proofs',
        loadComponent: () => import('./pages/admin/payment-proofs/payment-proofs.component').then(m => m.AdminPaymentProofsComponent),
        title: 'Comprobantes | Admin | CodeLand SaaS'
      },
      {
        path: 'tenants',
        loadComponent: () => import('./pages/admin/tenants/tenants.component').then(m => m.AdminTenantsComponent),
        title: 'Negocios | Admin | CodeLand SaaS'
      },
      {
        path: 'subscriptions',
        loadComponent: () => import('./pages/admin/subscriptions/subscriptions.component').then(m => m.AdminSubscriptionsComponent),
        title: 'Suscripciones | Admin | CodeLand SaaS'
      },
      {
        path: 'plans',
        loadComponent: () => import('./pages/admin/plans/plans.component').then(m => m.AdminPlansComponent),
        title: 'Planes | Admin | CodeLand SaaS'
      },
      {
        path: 'settings',
        loadComponent: () => import('./pages/admin/settings/settings.component').then(m => m.AdminSettingsComponent),
        title: 'Configuracion | Admin | CodeLand SaaS'
      },
      {
        path: 'notificaciones',
        loadComponent: () => import('./pages/admin/notificaciones/notificaciones-admin.component').then(m => m.NotificacionesAdminComponent),
        title: 'Enviar Notificación | Admin | CodeLand SaaS'
      },
      {
        path: 'promociones',
        loadComponent: () => import('./pages/admin/promociones/promociones-admin.component').then(m => m.PromocionesAdminComponent),
        title: 'Promociones | Admin | CodeLand SaaS'
      },
      {
        // Certificados de ARCA. Va en el panel admin y no en el app del comercio: el
        // certificado compartido sostiene la facturacion de todos los comercios.
        path: 'afip-certificados',
        loadComponent: () => import('./pages/admin/afip-certificados/afip-certificados.component').then(m => m.AfipCertificadosComponent),
        title: 'Certificados de ARCA | Admin | CodeLand SaaS'
      },
      {
        path: 'ayuda',
        loadComponent: () => import('./pages/admin/ayuda/ayuda-admin.component').then(m => m.AyudaAdminComponent),
        title: 'Cómo funciona | Admin | CodeLand SaaS'
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      }
    ]
  },

  // Error pages
  {
    path: '**',
    loadComponent: () => import('./pages/other-page/not-found/not-found.component').then(m => m.NotFoundComponent),
    title: 'Not Found | CodeLand SaaS'
  }
];
